import React from "react";

import OverviewContainer from "../../../../../container/overview";
import { ESupplyChainOverviewTabs } from "../../../../../models/supply.chain.overview.configure";

const ContainersOverviewPanel = () => {
  return <OverviewContainer panel={ESupplyChainOverviewTabs.CONTAINERS} />;
};

export default ContainersOverviewPanel;
